// https://github.com/Bleach-London/bleach-chat-api/wiki/V2-API
import { encode } from "base-64"
import {
    IMPORTANCE_NONBREAKING
} from "@/strings.js"

export default {
    getPartyId(partyLink, buuid) {
        return new Promise((res, rej) => fetch(`${process.env.VUE_APP_API_URL}/api/v2/live`, {
                method: "POST",
                headers: {
                "Content-Type": "application/json"
                },
                body: JSON.stringify({partyLink, buuid})
            })
            .then(response => res(response.json()))
            .catch(err => rej({
                importance: IMPORTANCE_NONBREAKING,
                error: err,
                code: 1
            }))
        )
    },
    getPartyDetails(partyId, buuid) {
        return new Promise((res, rej) => fetch(`${process.env.VUE_APP_API_URL}/api/v2/parties/${partyId}?buuid=${buuid}`, {
            method: "GET",
            headers: {
            "Content-Type": "application/json"
            }
        }).then(response => res(response.json()))
        .catch(err => rej({
            importance: IMPORTANCE_NONBREAKING,
            error: err,
            code: 2
        })))
    },
    modLogin(userName, password) {
        return new Promise((res, rej) => fetch(process.env.VUE_APP_API_URL + "/api/v2/moderator/login", {
            method: "POST",
            headers: new Headers({
              Authorization: "Basic " + encode(userName + ":" + password),
              "Content-Type": "application/json"
            })
          })
        .then(response => res(response.json()))
        .catch(err => rej({
            importance: IMPORTANCE_NONBREAKING,
            error: err,
            code: 3
        })))
    }
}